export default {
  noLikesFound: 'Nenhuma curtida encontrada',
  noMusicalGenresFound: 'Ainda não existem gêneros musicais',
  noArtistsFound: 'Ainda não há artistas.',
  noSongsFound: 'Ainda não há músicas',
  extraData: 'Informações adicionais',
  noExtraDataFound: 'Não há informações adicionais',
  typeOfRegister: 'Tipo de registro',
  createList: 'Criar lista',
  import: 'Importação',
  invitations: 'Convites',
  invite: 'Convidar',
  seeGuests: 'Ver convidados',
  addNew: 'Adicionar novo',
  mustChargeBeforeCreatePeople: 'Você deve cobrar dinheiro antes de criar pessoas',
  invited: 'Convidado',
  verified: 'Verificado',
  notVerified: 'Não verificado',
  imported: 'Importados',
  notImported: 'Não importado',
  oneTimePassword: 'Uma vez senha',
  changePassword: 'Alterar senha',
  deletePerson: 'Excluir pessoa',
  loading: 'Carregar',
  noPeopleRegistered: 'Nenhuma pessoa registrada',
  emailOrPhone: 'E-mail ou telefone',
  method: 'Método',
  creationDate: 'Data de criação',
  actions: 'Ações',
  customizedSearch: 'Pesquisa personalizada',
  state: 'Estado',
  createPerson: 'Criar pessoa',
  perPage: 'por página',
  loadFile: 'Carregar arquivo',
  organizeData: 'Organizar dados',
  verify: 'Verificar',
  pickToImportBusinessesOrPeopleToNewList: 'Escolha se você quiser importar empresas ou pessoas para uma lista nova ou existente',
  pickToSavePeopleToList: 'Escolha se você quiser salvar as pessoas que você está importando em uma lista',
  business: 'Negócio',
  existentList: 'Lista existente',
  newList: 'Nova lista',
  noList: 'Sem lista',
  listsNotCreated: 'Você não criou nenhuma lista',
  pickAList: 'Escolha uma lista',
  typeNameOfTheList: 'Digite o nome da lista',
  uploadFileTypeInfo: 'Carregue o arquivo onde você tem seus contatos salvos no formato CSV ou xlsx',
  pickFile: 'Escolher arquivo',
  identifyImportedFields: 'Identifique cada campo com base nas informações que ele vai conter',
  newColumnName: 'Novo nome da coluna',
  verifyInfoBeforeListCreation: 'Verifique se as informações estão corretas antes de criar a lista',
  cancel: 'Cancelar',
  goBack: 'Voltar',
  continue: 'Continuar',
  message: 'Mensagem',
  other: 'Outros',
  contact: 'Contato',
  company: 'Empresa',
  address: 'Endereço',
  document: 'Documento',
  image: 'Imagem',
  location: 'Localização',
  observation: 'Observação',
  position: 'Posição',
  phone: 'Telefone',
  phonePaste: 'Telefone para colar',
  phoneWrite: 'Escreva o número de telefone',
  validPhone: 'Número de telefone válido',
  invalidPhone: 'Telefone inválido',
  switchPasteModePhone: 'Mudar para o modo colar entrada do telefone',
  switchWriteModePhone: 'Mudar para a entrada do telefone em modo de escrita',
  pickWhereToSavePeopleToImport: 'Escolha onde salvar as pessoas que você vai importar',
  pleaseAddAValidFile: 'Por favor adicione um arquivo válido',
  errorReadingTheFile: 'Houve um erro lendo o arquivo',
  newPerson: 'Nova pessoa',
  password: 'Senha',
  addNewPerson: 'Adicionar nova pessoa',
  personSuccessfullyAdded: 'Pessoa adicionada com sucesso',
  sendEmailTo: 'Enviar e-mail para',
  sendSMSTo: 'Enviar SMS para',
  call: 'Chamar',
  downloadContact: 'Baixe contato',
  editUser: 'Editar usuário',
  know: 'Sei',
  connect: 'Conectar',
  emailVerify: 'Email Verificar',
  talk: 'Tlk',
  tasks: 'Tarefas',
  record: 'Ações',
  addPersonEmailOrPhoneToNotifyAboutTaskStatus: 'Adicione e-mail ou telefone para enviar notificações sobre o status da tarefa',
  observations: 'Observações',
  editTask: 'Editar tarefa',
  youMustAddTheNameOfTheTask: 'Você deve adicionar o nome da tarefa',
  sameNameTask: 'Uma tarefa com esse nome já existe',
  taskSuccessfullyDeleted: 'Tarefa excluída com sucesso',
  noPersonNotes: 'Este usuário não tem notas salvas',
  insertNewNote: 'Insira uma nova nota',
  currentNotes: 'Notas salvas',
  editNote: 'Edite esta nota',
  deleteNote: 'Exclua esta nota',
  errorUpdatingNotes: 'As notas não puderam ser atualizadas',
  clickPendingTasks: 'Clique para ver os detalhes das tarefas',
  tasksList: 'Lista de tarefas',
  tasksDueToday: 'Due Today',
  tasksDueAfter: 'Devido depois',
  tasksDueBefore: 'Devido Antes',
  daysRemaining: 'Dias restantes',
  extraManagementAddNewField: 'Adicionar novo campo de informações',
  extraManagementAditionalInfo: 'Informações adicionais de pessoas de sua marca',
  extraManagementItemAccessApplication: 'Só pode ser visto por um administrador deste aplicativo',
  extraManagementItemAccessPerson: 'Pode ser visto pelo povo',
  extraCreatorShortText: 'Campo de texto curto',
  extraCreatorLongText: 'Grande campo de texto',
  extraCreatorList: 'Lista suspensa',
  extraCreatorRadioList: 'Lista de botões de rádio',
  extraCreatorCheckList: 'Lista de caixas de seleção',
  extraCreatorEmail: 'E-mail',
  extraCreatorCreateField: 'Crie um campo de informações adicionais',
  extraCreatorEditField: 'Editar um campo de informações adicionais',
  extraCreatorFieldName: 'Nome do campo',
  extraCreatorFieldType: 'Tipo de campo',
  extraCreatorFieldAccess: 'Acesso ao campo',
  extraCreatorAddOptions: 'Adicione as opções',
  extraCreatorOption: 'Opção',
  extraCreatorApplication: 'Aplicação',
  extraCreatorApplicationInfo: 'Permita que o aplicativo visualize e modifique este campo do administrador',
  extraCreatorPersonInfo: 'Permite que os usuários visualizem e modifiquem este campo a partir de seu perfil',
  extraCreatorAddTags: 'Adicione algumas tags',
  extraCreatorMessageEnterTag1: 'Nenhum resultado correspondente',
  extraCreatorMessageEnterTag2: 'Pressione',
  extraCreatorMessageEnterTag3: 'para criar um novo',
  setResponsible: 'Definir um responsável',
  assign: 'Atribuir',
  selectResponsible: 'Selecione os responsáveis por esta lista de novos usuários',
  pickAResponsible: 'Escolha um responsável',
  selectResponsibleSolo: 'Selecione um responsável por este usuário',
  seeLess: 'Veja menos',
  favoriteSongs: 'Músicas favoritas',
  favoriteMusicalGenres: 'Gêneros musicais favoritos',
  favoriteArtists: 'Artistas favoritos',
  noInstagramSpotifyTags: 'Ainda não existem preferências do Instagram ou spotify',
  addToList: 'Adicionar à lista',
  noPersonRecords: 'Este usuário não tem um registro de ações',
  personAddedToList: 'Pessoa adicionada à lista',
  messageSuccessfullySent: 'Mensagem enviada com sucesso',
  loadCsv: 'Carregar CSV',
  insertInvitedPeopleEmailPhone: 'Insira todos os e-mails ou telefones das pessoas que você deseja convidar separados por vírgulas',
  noEmail: 'Sem e-mail',
  noPhone: 'Sem telefone',
  noLoadedInvitations: 'Sem convites carregados',
  downloadCsv: 'Baixar CSV',
  invitePerson: 'Pessoa convidada',
  inviteAdministrator: 'Convidar o administrador',
  invitedPeople: 'Pessoas convidadas',
  sendSms: 'Enviar SMS',
  resendInvitations: 'Resend convites',
  noInvitationsSent: 'Nenhum convite enviado',
  noAssistantSelected: 'Você não selecionou nenhum assistente',
  thisEmailIsGoingToBeSentTo: 'Este e-mail será enviado para',
  assistants: 'Assistentes',
  noPersonSelected: 'Você não selecionou nenhuma pessoa',
  allTheEventAssistants: 'todos os assistentes {event}',
  close: 'Perto',
  send: 'Enviar',
  accept: 'Aceitar',
  actualPassword: 'Senha real',
  change: 'Mudar',
  youAreAboutToChangeUserPassword: 'Você está prestes a alterar {user}Â\'s senha lembre-se de dizer à pessoa a nova senha',
  saveChanges: 'Salvar alterações',
  onetimePasswordUse: 'Esta senha só pode ser usada uma vez',
  sendToPersonEmail: 'Enviar para o e-mail da pessoa',
  sendToPersonPhone: 'Enviar para o telefone da pessoa',
  generatePassword: 'Gerar senha',
  passwordCopiedToClipboard: 'A senha foi copiada para a área de transferência',
  errorCopyingThePassword: 'Erro copiando a senha',
  doYouWantToDeleteThisPerson: 'Você quer excluir essa pessoa?',
  personSuccessfullyDeleted: 'Pessoa excluída com sucesso',
  selectFinishingDate: 'Selecione a data de término',
  pick: 'Escolher',
  selectFinishingHour: 'Selecione a hora de chegada',
  createTask: 'Criar tarefa',
  currentTasks: 'Tarefas atuais',
  noTasksToDo: 'Não há tarefas para fazer',
  hour: 'Hora',
  date: 'Data',
  moveToDoneTasks: 'Mova-se para tarefas feitas',
  deleteTask: 'Excluir tarefa',
  completedTasks: 'Tarefas concluídas',
  noCompletedTasks: 'Não há tarefas concluídas',
  moveToUndoneTasks: 'Mova-se para tarefas desfeitas',
  errorUpdatingTasks: 'Não foi possível atualizar tarefas',
  enterTheNameAndDescriptionOfTheTask: 'Digite o nome e as observações da tarefa',
  insertANewTask: 'Insira uma nova tarefa',
  editProfile: 'Editar perfil',
  insertFullName: 'Insira seu nome completo',
  insertYourEmail: 'Insira seu e-mail',
  addRoles: 'Adicionar papéis',
  description: 'Descrição',
  userDescription: 'Descrição do usuário',
  notes: 'Notas',
  addCommentsAboutThisPerson: 'Adicione comentários sobre essa pessoa',
  noInformation: 'Não há informações.',
  updatedCorrectly: 'Atualizado corretamente',
  searchCountry: 'País de busca',
  countryNotFound: 'País não encontrado',
  uploadDocument: 'Enviar documento',
  downloadDocument: 'Baixar documento',
  editDocument: 'Editar documento',
  deleteDocument: 'Excluir documento',
  documents: 'Documentos',
  deleteDocumentConfirmation: 'Você realmente quer excluir este documento?',
  insertDocumentDescription: 'Digite a descrição do documento',
  editDescription: 'Editar descrição',
  documentSuccessfullyDeleted: 'Documento excluído com sucesso',
  youMustPickADocumentToEdit: 'Você deve escolher um documento para editar',
  fileSizeMustBeUnderXSize: 'O tamanho do arquivo anexado deve estar abaixo do tamanho {}',
  documentSuccessfullyEdited: 'Documento excluído com sucesso',
  documentSuccessfullyUploaded: 'Documento carregado com sucesso',
  editList: 'Lista de edição',
  listCorrectlyUpdated: 'Lista atualizada corretamente',
  personDeletedFromList: 'Pessoa excluída da lista',
  doYouWantToDeleteThisList: 'Você deseja excluir esta lista',
  deleteList: 'Lista de exclusão',
  listDeleted: 'Lista excluída',
  lists: 'Listas',
  create: 'Criar',
  campaign: 'Campanha',
  peopleLists: 'listas de pessoas',
  peopleListsNotCreated: 'Você não criou nenhuma lista de pessoas',
  peopleInTheList: 'Pessoas na lista',
  listName: 'Nome da lista',
  waitUntilTheListGetsCreated: 'Aguarde até que a lista seja criada',
  loadingPeopleFromTheList: 'Carregando pessoas da lista',
  noPeopleInThisList: 'Não há pessoas nesta lista.',
  rolesNotCreated: 'Não há papéis criados',
  code: 'Código',
  nameOfTheRol: 'Nome do rol',
  newRol: 'Novo rol',
  addNewRol: 'Adicionar novo rol',
  rolSuccessfullyCreated: 'Rol criado com sucesso',
  editRol: 'Editar rol',
  rolSuccessfullyEdited: 'Rol editado com sucesso',
  columnsTable: 'Colunas',
  edit: 'Editar',
  loadingPerson: 'Carregando pessoa',
  weCouldNotFindThisPerson: 'Não conseguimos encontrar essa pessoa',
  youMustAddKeyToUpdateUser: 'Você deve adicionar uma chave para atualizar esta pessoa',
  noDocumentsWereFoundForThisPerson: 'Não há documentos enviados associados a esta pessoa',
  email: 'E-mail',
  verifyEmail: 'Verificar e-mail',
  roles: 'Funções',
  updateAppPublicKey: 'Atualizar chave pública do aplicativo',
  emailSuccessfullyVerified: 'Email verificado com sucesso',
  closeProfile: 'Fechar perfil',
  journey: 'Viagem',
  noJourneyForCurrentApp: 'Seu aplicativo não possui uma Jornada associada, crie uma para adicionar ou alterar o status atual da Jornada dessa pessoa',
  changeJourneyCurrentStatus: 'Alterar o status atual da jornada desta pessoa',
  dependsOn: 'Depende de',
  journeyId: 'Journey ID',
  isDependencyOf: 'É dependência de',
  changeJourneyCurrentStatusWarning: 'Você tem certeza de alterar o status atual dessa pessoa Journey?',
  changeJourneyStatus: 'Alterar o status atual da jornada',
  customFields: 'Os campos personalizados',
  seeFilters: 'Ver filtros',
  hideFilters: 'Ocultar filtros',
  peopleFilters: 'Filtros de pessoas',
  clearFields: 'Limpar campos',
  startEditingMode: 'Iniciar o modo de edição',
  stopEditingMode: 'Parar o modo de edição',
  createNewTaskToAssignInBlock: 'Crie a nova tarefa para atribuir no bloco',
  taskCreatedSuccessfully: 'Tarefa criada com sucesso',
  chooseTheTypeOfBlockEdition: 'Comece selecionando o tipo de edição de bloco que você deseja fazer para iniciar o processo',
  modifyTheAdditionalDataThatYouWant: 'Modifique os dados adicionais que você deseja',
  justTheFilledExtraDataAreGoingToBeChanged: 'Apenas os dados extras com algumas informações preenchidas serão editados, o restante deles será ignorado',
  pickTheJourneyStatusToAssignInBlock: 'Escolha um status de viagem para atribuir no bloco',
  editInBlock: 'Editar no bloco',
  enterInformation: 'Inserir informações',
  modifyAtLeastOneExtraDataToEditInBlock: 'Você deve modificar pelo menos um extraData para poder editar no bloco',
  addAJourneyStatusToEditInBlock: 'Você deve adicionar um status de Jornada para editá-lo no bloco',
  createAValidTaskToAddInBlock: 'Você deve criar uma tarefa válida para adicioná-la no bloco',
  editPeopleInBlock: 'Editar pessoas no bloco',
  aListWithThisNameAlreadyExists: 'Já existe uma lista com esse nome',
  addTheNameOfTheListToBeCreated: 'Adicione o nome da lista a ser criada',
  changeExtraData: 'Alterar informações adicionais',
  pickAtLeastOneTypeOfEditingToEditInBlock: 'Você deve escolher pelo menos um tipo de edição e preencher as informações correspondentes',
  editInBlockFinishedSuccessfully: 'Editar no bloco concluído com sucesso',
  youMustAddTagsInOrderToFilterExtraData: 'Você deve adicionar tags aos dados extras para filtrá-los por tags',
  menu: 'Cardápio',
  of: 'do',
  responsible: 'Responsável',
  addPersonToBusiness: 'Adicionar pessoa ao negócio',
  businessSuccessfullyAdded: 'Empresa adicionada com sucesso',
  enterPersonPositionInBusiness: 'Insira a posição da pessoa no negócio',
  searchABusinessToAdd: 'Pesquise uma empresa para adicionar',
  thisPersonHasNoBusinesses: 'Esta pessoa não tem negócios associados',
  fullName: 'Nome completo',
  firstName: 'Primeiro nome',
  onlyStaticListsAreListedBelow: 'Apenas listas estáticas são listadas abaixo',
  listType: 'Tipo de lista',
  static: 'Estática',
  dynamic: 'Dinâmica',
  mainPhone: 'Telefone principal',
  profile: 'Perfil',
  initConversationWithWhatsappChannel: 'Iniciar conversa de whatsapp',
  activateWhatsappBusiness: 'Ative o WhatsApp Business Official',
  orderExtraData: 'Classificar fados adicionais',
  tags: 'Tags',
  noTags: 'Sem tags',
  privacyTermsWarning: 'Exportar dados não é uma boa prática, pois pode violar a lei 1581 e o GDPR. Tem certeza de que deseja exportar os dados?',
  registerName: 'Registrar o nome?',
  sendEmail: 'Enviar email',
  editResponsible: 'Responsável pela edição',
  permissionsFor: 'Permissões para',
  // Importing people info
  numberOfRows: 'Numero de linhas',
  totalPeople: 'Total de pessoas',
  uniquePeople: 'Pessoas únicas',
  savedPeople: 'Pessoas salvas',
  updatedPeople: 'Pessoas atualizadas',
  insertedPeople: 'Pessoas inseridas',
  duplicatedPeople: 'Pessoas duplicadas',
  importCompleted: 'Importação concluída',
  importingBusinesses: 'Negócios importadores',
  creatingList: 'Criando lista',
  peopleRegistrationInformation: 'Informações cadastrais das pessoas para o período selecionado',
  businessInformationItems: 'Colunas de informações comerciais',
  personalInformationItems: 'Colunas de informações pessoais',
  extraDataItems: 'Colunas de informações adicionais',
  doYouWantToDeleteThisRol: 'Você realmente deseja excluir este rol',
  rolSuccessfullyDeleted: 'Rol excluído com sucesso',
  addSelectedUsersToList: 'Adicionar usuários selecionados à lista',
  usersSuccessfullyAddedToList: 'Usuários adicionados à lista com sucesso'
}
